import SetupRmSnywSmsModal from './setup-rm-snyw-sms-modal.vue'
export default SetupRmSnywSmsModal
